module.exports = __webpack_public_path__ + "img/Expo_Topic1.d6f1f1b7.png";